export default function ({commit}, {value, field}) {

    let data = {};
    switch (field) {
        case 'Contragent':
            data = {
                ContragentId: value.value,
                ContragentName: value.label,
                ContragentSearchTypeId: value.type,
            };
            break;
        default:
            data[field] = value;
    }
    commit('set', data);
}